import {Component, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {Select, Store} from '@ngxs/store';
import {Observable, Subscription, take, tap} from 'rxjs';
import {PrimeNGConfig} from "primeng/api";
import {Emittable, Emitter} from "@ngxs-labs/emitter";
import {DataState} from "./store/data.state";
import {IconService} from "./shared/services/icon.service";
import {environment} from "../environments/environment";
import {Title} from "@angular/platform-browser";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy {

  @Select((state: any) => state.whitebricks.configuration?.theming?.appBgColor)
  public appBgColor$!: Observable<string>;
  @Emitter(DataState.getFEConfigurationOnStart)
  private getFEConfiguration!: Emittable<string>;
  private readonly subscriptions = new Subscription();

  constructor(private readonly renderer: Renderer2,
              private readonly primengConfig: PrimeNGConfig,
              private readonly store: Store,
              private readonly iconService: IconService,
              private readonly titleService: Title,
              private readonly translateService: TranslateService
  ) {
    const flowIdFromSession = this.store.selectSnapshot<string>((state: any) => state.whitebricks.flowId);
    if (flowIdFromSession) {
      this.getFEConfiguration.emit(flowIdFromSession);
    }
    this.translateService.addLangs(['cs', 'en', 'sk']);
    this.iconService.setFavicon(environment.cdnPath + '/logos/finbricks/whitebricks/whitebricks-favicon.ico');
    this.translateService.use(this.store.selectSnapshot((state: any) => state.whitebricks.language));
    this.subscriptions.add(this.translateService.onLangChange.pipe(
      tap(() => this.titleService.setTitle(this.translateService.instant('page.title')))
    ).subscribe());
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngOnInit() {
    this.primengConfig.ripple = true;
    this.appBgColor$.pipe(
      take(2),
      tap((res) => this.renderer.setStyle(document.body, 'background-color', res))
    ).subscribe();
  }
}
